import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import Header from '../../components/ui/Header';
import HeroSection from './components/HeroSection';
import AgentShowcase from './components/AgentShowcase';

const HomeLanding = () => {
  useEffect(() => {
    // Scroll to top on page load
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>Ipsos Intelligence Platform - Internal Market Research Automation</title>
        <meta 
          name="description" 
          content="Internal Ipsos platform for AI-driven market research automation. Survey data scraping, analysis, and client projections for research professionals." 
        />
        <meta 
          name="keywords" 
          content="Ipsos, internal tools, market research, AI automation, survey analysis, data scraping, client projections" 
        />
        <meta property="og:title" content="Ipsos Intelligence Platform" />
        <meta 
          property="og:description" 
          content="Internal Ipsos platform for market research automation and data analysis workflows." 
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://ipsos-internal.com" />
        <meta 
          property="og:image" 
          content="https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=1200&h=630&fit=crop" 
        />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Ipsos Intelligence Platform" />
        <meta 
          name="twitter:description" 
          content="Internal AI-driven market research automation platform for Ipsos professionals." 
        />
        <link rel="canonical" href="https://ipsos-internal.com" />
      </Helmet>
      <div className="min-h-screen bg-background">
        <Header />
        
        <main className="pt-16">
          <HeroSection />
          <AgentShowcase />
        </main>

        {/* Footer */}
        <footer className="bg-card border-t border-border py-12">
          <div className="container mx-auto px-6">
            <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
              {/* Company Info */}
              <div className="col-span-1 md:col-span-2">
                <div className="flex items-center space-x-3 mb-4">
                  <div className="w-8 h-8 bg-gradient-to-br from-primary to-secondary rounded-lg flex items-center justify-center">
                    <span className="text-white font-bold text-sm">IP</span>
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold text-card-foreground">Ipsos Platform</h3>
                    <p className="text-xs text-text-secondary">Internal Intelligence Platform</p>
                  </div>
                </div>
                <p className="text-text-secondary mb-4 max-w-md">
                  Empowering Ipsos research professionals with AI-driven automation for survey data scraping, analysis, and client projections.
                </p>
                <div className="flex items-center gap-4 text-sm text-text-secondary">
                  <span>© {new Date()?.getFullYear()} Ipsos Internal Platform</span>
                  <span>•</span>
                  <a href="#" className="hover:text-primary transition-colors">Privacy Policy</a>
                  <span>•</span>
                  <a href="#" className="hover:text-primary transition-colors">Terms of Service</a>
                </div>
              </div>

              {/* Quick Links */}
              <div>
                <h4 className="font-semibold text-card-foreground mb-4">Platform</h4>
                <ul className="space-y-2 text-sm text-text-secondary">
                  <li><a href="#" className="hover:text-primary transition-colors">AI Agents</a></li>
                  <li><a href="#" className="hover:text-primary transition-colors">Analytics</a></li>
                  <li><a href="#" className="hover:text-primary transition-colors">Integrations</a></li>
                  <li><a href="#" className="hover:text-primary transition-colors">Documentation</a></li>
                </ul>
              </div>

              {/* Support */}
              <div>
                <h4 className="font-semibold text-card-foreground mb-4">Support</h4>
                <ul className="space-y-2 text-sm text-text-secondary">
                  <li><a href="#" className="hover:text-primary transition-colors">Help Center</a></li>
                  <li><a href="#" className="hover:text-primary transition-colors">IT Support</a></li>
                  <li><a href="#" className="hover:text-primary transition-colors">System Status</a></li>
                  <li><a href="#" className="hover:text-primary transition-colors">Training</a></li>
                </ul>
              </div>
            </div>
          </div>
        </footer>
      </div>
    </>
  );
};

export default HomeLanding;